import React, { Component } from "react";

import { TAKS_IMPORT } from "../../config/lang";
import Map from "../dashboard/_/map_block/Map";

import { call } from "../../util/action";
import { translate } from "../../util/util";

class View extends Component {
  constructor(props) {
    super(props);

    this.state = {
      location: {},
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;

    if (id !== "new") {
      this.load(id);
    }
  }

  load = id => {
    call({ method: "GET", url: "points/" + id + "/" }, item => {
      let location = {
        address: item.address,
        lat: item.location.latitude,
        lng: item.location.longitude,
      };

      this.setState({ item: item, location: location });
    });
  };

  handleBack = () => {
    this.props.history.replace("/point");
  };

  render() {
    let { item } = this.state;
    const { currentUser } = this.props;
    const hasNetworkImage = item && item.network && item.network.image;

    return (
      <div className="container-fluid pt-view">
        <div className="pt-top-bar">
          <button className="pt-back-btn" onClick={this.handleBack}>
            <span className="material-symbols-outlined">arrow_back</span>
            {translate(TAKS_IMPORT, "view_the_point", currentUser.language)}
          </button>
        </div>

        <div className="pt-layout">
          <div className="pt-info-card">
            <div className="pt-info-header">
              <div className="pt-network-logo">
                {hasNetworkImage ? (
                  <img src={item.network.image} onError={e => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }} />
                ) : null}
                <span className="pt-network-logo-fallback" style={hasNetworkImage ? { display: "none" } : {}}>
                  <span className="material-symbols-outlined">store</span>
                </span>
              </div>
              <div className="pt-info-titles">
                <span className="pt-network-name">{item && item.network && item.network.name}</span>
                <h2 className="pt-point-name">{item && item.name}</h2>
              </div>
            </div>

            <div className="pt-fields">
              <div className="pt-field">
                <span className="material-symbols-outlined pt-field-icon">location_on</span>
                <div className="pt-field-content">
                  <span className="pt-field-label">{translate(TAKS_IMPORT, "addresses_label", currentUser.language)}</span>
                  <span className="pt-field-value">{item && item.address}</span>
                </div>
              </div>
              <div className="pt-field">
                <span className="material-symbols-outlined pt-field-icon">my_location</span>
                <div className="pt-field-content">
                  <span className="pt-field-label">{translate(TAKS_IMPORT, "coordinates_label", currentUser.language)}</span>
                  <span className="pt-field-value">{item && item.location.latitude + ", " + item.location.longitude}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-map-card">
            {item && <Map title={item && item.network && item.network.name} imageSrc={hasNetworkImage ? item.network.image : null} location={this.state.location} zoomLevel={13} />}
          </div>
        </div>
      </div>
    );
  }
}

export default View;